var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.11 30.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    cx: 13.87,
    cy: 7.84,
    r: 7.34
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    d: "M9.95,18.27h7.21c5.21,0,9.45,4.23,9.45,9.45v2.36H.5v-2.36c0-5.21,4.23-9.45,9.45-9.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.02fb725b20e0109666447d470c6ea43d.svg";
export { ForwardRef as ReactComponent };